export const DROPDOWN_VALUE = 'dropdown_value'
export const SAVE_ACCOUNT = 'save_account'
export const UPDATE_ACCOUNT = 'update_account'
export const ACCOUNT_DETAILS = 'account_details'
export const ACCOUNT_DETAILS_BY_ID = 'account_details_by_id'
export const FETCH_REPORTEE = 'fetch_reportee'
export const ACCOUNT_FILTER = 'account_filter'
export const GEO_CITY = 'geo_city'
export const GET_ACCOUNT_ACTIVITY = 'get_account_activity'
export const GET_ACCOUNT_ACTIVITY_BY_ID = 'get_account_activity_by_id'
export const SAVE_ACTIVITY = 'save_Activity'
export const GET_ACCOUNT_ACTIVITY_LIST = 'get_account_activity_list'
export const GET_V2_OPPORTUNITY_ACTIVITY_TYPE = 'get_v2_opportunity_activity_type'
export const GET_LAST_LEAD_OPPORTUNITY_ACTIVITY = 'get_last_lead_opportunity_activity'
export const IS_USER_CHECK_IN = 'Is_User_Check_In'
export const INFRA_PROJECT = 'Infra_Project'
export const SAVE_BUSINESS = 'Save_Business'
export const GET_INSPECTION_LIST = 'GET_INSPECTION_LIST'
export const PROFILE = 'PROFILE'